export default __webpack_public_path__ + "static/media/chumbo-pic.a90a84e6.png";